import React, {useEffect, useState, useRef} from 'react';
import { json, useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'react-quill/dist/quill.snow.css';
import { faBars } from "@fortawesome/free-solid-svg-icons";
import '../css/CreatePost.css';
import ReactQuill from 'react-quill';
import Text from '../../../common/Text.js';


function CreatePost() {

  const location = useLocation();
  const firstnewsList = location.state?.firstnewsList; //수정 초기데이터 리스트
  const newsList = location.state?.newsList; //수정 데이터 리스트
  const item = location.state?.item; //새글인지 수정글인지 구분해주는 구분자
  const MenuNm = location.state?.MenuNm; //화면 명이 뭔지 구분해주는 구분자 ex) 보도자료인지 메거진인지


    useEffect( ()  => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
      console.log(newsList);
      console.log('재마운트');                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
      console.log(files);
      console.log('재마운트2');        
      console.log(metafiles);


       if(newsList != undefined){
        setTitleValue(newsList.Title);
        setViewsValue(newsList.Views);
        setMediaCompValue(newsList.MediaComp);
        setURLValue(newsList.Url);
        setContentValue(newsList.Contents);
        setGbnValue(newsList.Gbn);
        setItemValue(item);
        console.log(newsList);
        console.log(newsList.UploadID);
        setUploadId(newsList.UploadID);


        axios.get('/api/FileListSelect', { params: { uploadkey: newsList.UploadID } })
        .then(response => {
            const formattedFiles = response.data.map(fileInfo => ({
                name: fileInfo.FileNm,
                uploadId: fileInfo.UploadID,
                fileId: fileInfo.Fileid,
            }));

            console.log(JSON.stringify(formattedFiles) + " FileListSelect - Formatted");
            
            setfirstfiles(prevFiles1 => [...prevFiles1, ...formattedFiles]);
            setFiles(prevFiles => [...prevFiles, ...formattedFiles]);
            setmetaFiles(prevFiles1 => [...prevFiles1, ...formattedFiles]);
        })
        .catch(error => {
            console.log(error);
            alert('기존 파일 목록을 불러오는데 실패했습니다.');
        }, []);




        // axios.get('/api/FileListSelect', { params: { uploadkey: newsList.UploadID } })
        // .then(response => {
        //     // API 응답 데이터를 원하는 형태로 변환
        //     const formattedFiles = response.data.map(fileInfo => ({
        //         // 예를 들어 API 응답에 fileName이 있다면 name으로 매핑
        //         name: fileInfo.FileNm,
        //         // 필요하다면 다른 속성도 매핑 또는 기본값 설정
        //         // size: fileInfo.fileSize || 0,
        //         // type: fileInfo.fileType || 'application/octet-stream',
        //         // uploadId 같은 고유 값도 같이 저장해두면 나중에 삭제할 때 유용해
        //         uploadId: fileInfo.UploadID 
        //     }));
        //     setFiles(formattedFiles); // 변환된 데이터로 상태 업데이트
        //     console.log(JSON.stringify(formattedFiles) + "FileListSelect - Formatted");
        // })
        // .catch(error => console.log(error));

        
        console.log('filesa1');
        console.log(files);
        console.log('filesa1');
        console.log('files');
        console.log('files');
        console.log('files');
        console.log('files');


       }
      
    }, []);


    //목록으로
    const navigate = useNavigate();
    const tolistBtnClick = () => {

      if(item == '01') //추가
      {
          //파일 리스트 전체 삭제
          const formData = new FormData();
          setFiles([]);
          // 선택된 각 파일에 대해 순회하며 업로드 진행

          console.log(formData);
          formData.append("uploadId", UploadId);
          axios.post('/deleteFiles', formData,
            {headers:{
                'Content-Type': 'multipart/form-data'
            }}
            ).then((res) => { 
              console.log('시작1111111111'); 
              setUploadId(res.data);   
              console.log(UploadId); 
            })
            .catch((err) => {console.error(err)}); 
      }
      else //수정
      {
          //파일 저장은 별도로 저장하기 떄문에 수정일때는 필요없음
      }

       if(MenuNm == 'News')
       {
         navigate('/News');}
       else
       {
         navigate('/CompanyMagazine');}
    };

  
    //삭제가 됬는지
    const [DeleteValue, setDeleteValue] = useState('1'); 

    //제목 입력값
    const [TitleValue, setTitleValue] = useState(''); 
    //조회수 입력값
    const [ViewsValue, setViewsValue] = useState(0); 
    //언론사 명 입력값
    const [MediaCompValue, setMediaCompValue] = useState(''); 
    //URL 입력값
    const [URLValue, setURLValue] = useState(''); 
    //내용 입력값
    const [ContentValue, setContentValue] = useState(''); 
    //이미지 첨부 입력값
    const [UploadId, setUploadId] = useState(''); 
    //글쓴이
    const [CreaterValue, setCreaterValue] = useState('관리자'); 
    //초기 파일ID
    const [firstfiles, setfirstfiles] = useState([]);
    //파일ID
    const [files, setFiles] = useState([]);
    //메타파일
    const [metafiles, setmetaFiles] = useState([]);
    //메타파일을 담아주는 메타 파일 리스트2
    const [metafiles2, setmetaFiles2] = useState([]);
    //파일ID
    const [UpdateFile, setUpdateFile] = useState([]);
    //Gbn 글번호(키값) 
    const [GbnValue, setGbnValue] = useState(0); 
    //item : 새글인지 수정글인지 구분해주는 구분자
    const [ItemValue, setItemValue] = useState('');
    const [FileGbnValue, setFileGbnValue] = useState(0); 

    



    //입력했을때 값 갱신해주는 로직
    //제목
    const handleTitleChange = (event) => {
        
        console.log('입력된 값:', event.target.value); 
    
        //현재 입력된 값으로 업데이트!
        setTitleValue(event.target.value);
      };

    //언론사
    const handleMediaChange = (event) => {
        
        console.log('입력된 값:', event.target.value); 
    
        //현재 입력된 값으로 업데이트!
        setMediaCompValue(event.target.value);
      };

    //URL
    const handleURLChange = (event) => {
        
        console.log('입력된 값:', event.target.value); 
    
        //현재 입력된 값으로 업데이트!
        setURLValue(event.target.value);
      };

    //내용
    const handleContentChange = (event) => {
        
        console.log('입력된 값:', event.target.value); 
    
        //현재 입력된 값으로 업데이트!
        //setContentValue(event.target.value);
      };


      
      //글 삭제
      const toDelBtnClick = () => {
        if(window.confirm("삭제 하시겠습니까?")){
  
          console.log(MenuNm);
          console.log('삭제');
          axios.delete(`api/DelNewsList/${GbnValue}`) 
          .then((res) => {
            console.log('파일 삭제 성공!', res.data);
            if(MenuNm == 'News')
            {
              navigate('/News');}
            else
            {
              navigate('/CompanyMagazine');}
            // 삭제 성공 후 UI 업데이트 등 필요한 작업 수행
          })
          .catch((err) => {
            console.error('파일 삭제 실패!', err);
            // 에러 처리 로직
          });
          

          alert("삭제 되었습니다.");
        }
      };
      


      //db로 파일 저장하는 로직 
      async function SaveFileList() {
        try {
          
        const formData = new FormData();

          console.log(files);

        for (const file of files) {
          try {
            // AJAX를 통한 파일 업로드 요청
            formData.append("multipartFiles", file);
            console.log(file);
            
          } catch (error) {
          }
        }

        formData.append("uploadId", UploadId);

        console.log(UploadId);

        await axios.post('/uploadFilestemp', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then((res) => {
           // 업로드 ID 넣어주는 로직
           setUploadId(res.data);
           console.log(res.data);
           console.log('파일 저장 성공!');
           return res.data;
        }).catch((err) => {
          console.error("Axios 요청 중 에러 발생:", err.response ? err.response.data : err.message);
          alert("저장 중 오류가 발생했습니다. 다시 시도해주세요.");
      });

          
      
        } catch (err) {
          console.error(err);
          throw err; // 에러를 다시 던져서 호출하는 쪽에서 처리하도록 함
        }




      }





      //파일 업로드시 
      const handleFileChange = async (event) => {

        const selectedFiles = Array.from(event.target.files);
        const newFiles = [...files, ...selectedFiles];

        const formData = new FormData();
        console.log('newFiles');
        console.log(newFiles);
        for (const file of newFiles) {  
              try {
                // AJAX를 통한 파일 업로드 요청
                 
                formData.append("multipartFiles", file);
                console.log(file.uploadId);
                console.log('시작222233111');

              } catch (error) {
                // 파일 업로드 실패 시 에러 처리

              }
        }

        //////////////////////////////////////////////
        console.log('값이 있나');
        console.log(newsList);
        //////////////////////////////////////////////


        console.log('uploadid 넣어주sadsadasdasdasdasdasd는 구문1');

        const uploadid = null;

        //수정 일때 => db에서 데이터를 들고올 경우
        if(newsList !== undefined)
        {
          console.log(newsList);
          console.log(newsList.UploadID);
          console.log(newsList.UploadID !== undefined);
          console.log(newsList.UploadID !== null);
          if(newsList.UploadID !== undefined ||newsList.UploadID !== null )
          {
            console.log('uploadid');
            formData.append("uploadId", newsList.UploadID);
            console.log('uploadid3');
            setUploadId(newsList.UploadID); 
            console.log(uploadid);
          }
          else
          {
            formData.append("uploadId", '');
          }

          

         //DB에 파일 저장
         await axios.post('/AddFilestemp', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => { 

          setUploadId(res.data); 
          console.log('uploadid 넣어주는 구문2');
          console.log(res.data);
          console.log(UploadId);
        })
        .catch((err) => {console.error(err)}); 


          
          console.log('uploadid 넣어주는 구문1');
        }
        else //새글 일때 
        {
          formData.append("uploadId", '');

        //DB에 파일 저장
        await axios.post('/uploadFilestemp2', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => { 

          setUploadId(res.data); 
          console.log('uploadid 넣어주는 구문2');
          console.log(res.data);
          console.log(UploadId);
        })
        .catch((err) => {console.error(err)}); 
        }

 
  
     

      setFiles(newFiles);

      console.log('끝단')

      };




      // 파일 삭제2
      let handleFileRemove = async (fileToRemove, index) => {
      
        /*
          1. 글 등록 
          : UploadId로 삭제해야됨 => newUploadId => 

          2. 수정
          : FileId로 삭제해야됨 => newFileId
        */

        // 1. 글 등록

        let resultDt = null;

        console.log('데ㅂㅈㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷㄷ고옴!'); 
        console.log(UploadId); 

        axios.get('/api/FileListSelect',{params:{uploadkey:UploadId}})
        .then(response => {
          resultDt =   response.data;
          console.log('데이터 들고옴!'); 
          console.log(resultDt); 



          const formData = new FormData();
  
          const newFileId = String(resultDt[index].Fileid);
          formData.append("FileID", newFileId)
   
          //파일ID로 삭제
          axios.post('/DelFileList', formData,
            {headers:{
                'Content-Type': 'multipart/form-data'
            }}
            ).then((res) => { 
              console.log('등록 : 삭제!'); 
   
            })
            .catch((err) => {
              console.error("파일 삭제 오류", err);
              console.log("에러 상세:", err.response); // 👈 에러 응답 상세 정보 찍어보기!
            });


          }
       )
       .catch(error => console.error("DB 가져오기 오류", error));
       console.log('total sucess');




         /*
        if(item == '01') 
        {

          console.log('item : ' + item + ' 글쓰기');

          const formData = new FormData();
  
          formData.append("FileID", resultDt[index].Fileid)

          //파일ID로 삭제
          axios.post('/DelFileList', formData,
            {headers:{
                'Content-Type': 'multipart/form-data'
            }}
            ).then((res) => { 
              console.log('등록 : 삭제!'); 

            })
            .catch((err) => {console.error(err)}); 

        }
        
        // 2. 수정

        else //item = '02'
        {
          const formData = new FormData();
          const rawFileId = fileToRemove.fileId;
          const newFileId = String(rawFileId);


          formData.append("FileID", newFileId)

          //파일ID로 삭제
          axios.post('/DelFileList', formData,
            {headers:{
                'Content-Type': 'multipart/form-data'
            }}
            ).then((res) => { 
              console.log('수정 : 삭제!'); 

            })
            .catch((err) => {console.error(err)}); 
        }

        */


        //UI에 삭제된 파일 안보이도록 파일 업데이트
        setFiles(prevFiles => prevFiles.filter(file => file !== files[index]));


      };




      const params = new URLSearchParams();
      const params2 = new URLSearchParams();
      const param3 = new URLSearchParams();
      

      
      // #region  게시물 등록
      async function  SaveNewsList() {


        console.log(MenuNm);
        console.log('등록');

        let savedUploadId = null;
        try {
          //유효성 검사
        if(TitleValue.trim() === ""  ) {
          alert("제목에 빈값이 있습니다 다시 확인해주세요");
          return;
        }



            savedUploadId = UploadId;
            console.log(savedUploadId);

            const params = new URLSearchParams();

            params.append("Title", TitleValue);
            params.append("Views", ViewsValue);
            params.append("MediaComp", MediaCompValue);
            params.append("Url", URLValue);
            params.append("Contents", ContentValue);
            params.append("UploadID", savedUploadId); // SaveFileList에서 받아온 UploadId 사용
            params.append("Creater", CreaterValue);
    
    
            console.log('MenuNm1111111');

            setContentValue('');
            
            console.log(MenuNm);
            console.log('MenuNm222222222');

            if(MenuNm == "News")
            {
              const res2 = await axios.post('/api/SetNewsList', params);
              alert("저장이 완료되었습니다!");
              console.log('시작4444444~~~~~');
              navigate('/News');
               
            }
            else
            {
              const res4 = await axios.post('/api/SetMagzList', params);
              alert("저장이 완료되었습니다!");
              console.log('시작4444444~~~~~');
              navigate('/CompanyMagazine');

              console.log('사보 추가');
            }
        
                  
          }catch (error) {
            console.error("SaveNewsList 에러:", error);
            alert("뉴스 저장 중 오류가 발생했습니다.");
        }

      }
 // #endregion 


      // #region  글 수정
      const SaveUpdateClick = async (event) => {

        console.log(MenuNm);
        console.log('수정');

        //유효성 검사
        if(TitleValue.trim() === "" ) {
          alert("제목에 빈값이 있습니다 다시 확인해주세요");
          return;
        }

        setViewsValue(0);


          const formData2 = new FormData();
          
        let savedUploadId = null;
    

if((firstnewsList.Title == TitleValue && firstnewsList.MediaComp == MediaCompValue
  && firstnewsList.Url == URLValue && (firstnewsList.uploadId == UploadId &&  firstfiles.length == files.length)
  && firstnewsList.Contents == ContentValue) 
)
{
  alert("수정된 데이터가 없습니다!");
}
        else  //수정이 일어난경우
        {

          console.log('????');

          console.log(UploadId);
          console.log('????~??????????????????????');

          params.append("Title", TitleValue);
          params.append("Views", ViewsValue);
          params.append("MediaComp", MediaCompValue ?? null);
          params.append("Url", URLValue ?? null);
          params.append("Contents", ContentValue);
          params.append("UploadID", UploadId ); 
          params.append("Creater", CreaterValue); 
          params.append("Gbn", GbnValue); 
  
          setContentValue('');
          console.log(UploadId);
          console.log(newsList.uploadId);
          console.log('newsList.uploadId');
  
          await axios.put('/api/UpdateNewsList', params) 
          .then((res) => {
              console.log(res.data);
              console.log('수정 성공');
              //  SaveFileList(); //파일 저장
              alert("편집이 완료되었습니다!");

              
            if(MenuNm == "News"){
                navigate('/News');
              }
              else{
                navigate('/CompanyMagazine');
              }
          
          })
          .catch((err) => {
              console.error("Axios 요청 중 에러 발생:", err.response ? err.response.data : err.message);
              alert("저장 중 오류가 발생했습니다. 다시 시도해주세요.");
          });

        }


        

      }
// #endregion


async function deleteMetafilesSequentially(item) {

console.log(metafiles);
console.log(metafiles.length);

    if (!metafiles || metafiles.length === 0) {
        console.log("metafiles 배열이 비어있어 삭제할 파일이 없습니다.");
        return;
    }

    console.log(`metafiles에 있는 ${metafiles.length}개의 파일 삭제 시작...`);

    
        try {
            console.log('응 있네1111');

            // ⭐️⭐️⭐️ 여기서 params2 대신 FormData 객체를 새로 만들어서 사용해야 해! ⭐️⭐️⭐️
            const formData = new FormData();
            formData.append("FileID", item.fileId); // 서버가 원하는 "FileID" 이름으로 값을 넣어줘!

            console.log("삭제할 파일 ID:", item.fileId); // item.fileId 값 확인

            // ⭐️⭐️⭐️ axios.post의 두 번째 인자로 formData를 넘겨줘! ⭐️⭐️⭐️
            const res3 = await axios.post('/DelFileList', formData, {
                // FormData를 보내면 axios가 Content-Type을 알아서 multipart/form-data로 설정해줘.
                // 서버의 @RequestParam이 이걸 잘 받아먹을 거야!
            });

            // ⭐️ 요청 성공 시 처리 ⭐️
            console.log(`파일 삭제 성공 (fileId: ${item.fileId}):`, res3.data);

        } catch (error) {
            // ⭐️ 요청 실패 시 처리 ⭐️
            console.error(`파일 삭제 실패 (fileId: ${item.fileId}):`, error);
            // 400 에러가 여기서 잡힐 거야.
            // error.response.data 나 error.response.status 등을 찍어보면 더 자세한 정보를 볼 수 있어.
            if (error.response) {
                console.error("에러 응답 데이터:", error.response.data);
                console.error("에러 응답 상태 코드:", error.response.status);
            }
      
    }

    console.log("metafiles 파일 삭제 요청 완료.");
}




    //디자인
    return (

        <div className='root'>
            <link
  rel="stylesheet"
  href="https://unpkg.com/react-quill@1.3.3/dist/quill.snow.css"
/>
            <div className='write-container'>

                <div className='write-header'>
                    <div className='write-title'>보도자료</div>
                    <div className='write-title-line'></div>
                </div>


                {/* 1.제목 */}
                <div className='Title-container' >
                    <div className='title' style={{ margin: '-2.5px 0px 0px 0px'}}>제목</div>
                    <div className='title' style={{ color: 'red', margin: '-2.5px 0px 0px 0px'}}>*</div>
                    <input  type="text" //텍스트 입력창 타입
                            value={TitleValue} 
                            onChange={handleTitleChange} 
                            placeholder="여기에 입력하세요..."
                            style={{ margin: '0px 0px 0px 90px' , width : '866px'}}/>
                </div>


                {/* 언론사 명 */}
                <div className='Media-container' style={{ margin: '20px 0px 0px 0px' }}>
                    <div className='title' style={{ margin: '-2.5px 0px 0px 0px'}}>언론사 명</div>
                    <input  type="text" //텍스트 입력창 타입
                            value={MediaCompValue} 
                            onChange={handleMediaChange} 
                            placeholder="여기에 입력하세요..."
                            style={{ margin: '0px 0px 0px 49px' , width : '865px'}}/>
                </div>


                {/* URL */}
                <div className='url-container'  style={{ margin: '20px 0px 0px 0px' }}>
                    <div className='title' style={{ margin: '-2.5px 0px 0px 0px'}}>URL</div>
                    <input  type="text" //텍스트 입력창 타입
                            value={URLValue} 
                            onChange={handleURLChange} 
                            placeholder="여기에 입력하세요..."
                            style={{ margin: '0px 0px 0px 101px' , width : '865px'}}/>
                </div>

              
                {/* 파일 첨부*/}
                <div className='imgGr-container'  style={{ margin: '20px 0px 0px 0px', height:'245px' }}>
                    <div className='title' style={{ margin: '-2.5px 0px 0px 0px'}}>파일 첨부</div>
                    <div style={{ marginTop: '20px',  margin: '80px 0px 0px 48px' , padding: '0px 15px 0px 15px', border: '1px solid #ccc', borderRadius: '4px', width: '850px' }}>
                    <div className='coment' style={{ margin: '-70px 0px 18px -10px' ,color: 'red'}}>※ 파일은 첨부하시는 즉시 자동으로 저장됩니다. [편집 완료] 버튼과 별개로 처리됩니다. ※</div>
                    <div className='coment' style={{ margin: '-15px 0px 20px -10px' ,color: 'red'}}>※ DRM해제 후 업로드해주세요. ※</div>
                    <div className='coment' style={{ margin: '-17px 0px 20px -10px' ,color: 'red'}}>※ 용량이 큰 경우 시간이 걸립니다. ※</div>
                    {/* <h2>첨부파일</h2> */}
                        <input type="file" id="inputtag"  onChange={handleFileChange} style={{ display: 'none' , margin: '0px 0px 0px -5px' }} multiple  />
                        <label for="inputtag" 
                               style={{padding: '6px 14px',
                                       background: '#828282',
                                       color: '#fff',
                                       border: 'none',
                                       borderRadius: '4px',
                                       margin: '0px 0px 0px -5px',
                                       cursor: 'pointer',}}> 파일 업로드</label>
                         
                        
                        <ul style={{ marginTop: '20px', padding: '0', listStyle:'', maxHeight: '130px' ,overflow: 'auto' , display:'Block'}}>
                            {files.map((file, index) => (
                                <li key={index}
                                    style={{
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '5px',
                                    padding: '5px 10px',
                                    borderBottom: '1px solid #ddd',
                                }}>
                                    {file.name}

                                    <button
                                      onClick={() => handleFileRemove(file, index)}
                                      style={{
                                                marginLeft: '10px',
                                                padding: '4px 8px',
                                                background: '#828282',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                            }}>
                                     삭제
                                    </button>

                                </li>
                            ))}  
                        </ul>
                            
                     </div>
                </div>


                {/* 내용 */}
                <div className='Content-container'  style={{ margin: '20px 0px 0px 0px' }}>
                    <div className='title' style={{ margin: '-2.5px 0px 0px 0px'}}>내용</div>
                    <div className='title' style={{ color: 'red', margin: '-2.5px 0px 0px 0px'}}>*</div>
                    <div>
                        <ReactQuill theme="snow" value={ContentValue} onChange={setContentValue} 
                                    style={{ margin: '0px 0px 0px 88px', width : 889, height : 450}}/>
                    </div>
                </div>


                <div className='Title-container' style={{ margin: '520px 0px 0px 0px',  textAlign: 'center', display : 'inline-block'}}  >
                    <button className='btnMain' style={{ margin: '0px 0px 0px 10px'}} onClick={() => tolistBtnClick()}>취소</button>
                    {item == '01' ? null : <button className='btnMain' style={{ margin: '0px 0px 0px 10px'}} onClick={() => toDelBtnClick()}>삭제</button>}
                    {item == '01' ? <button className='btnMain' style={{ margin: '0px 0px 0px 10px'}} onClick={() => SaveNewsList()}>등록</button> 
                    : <button className='btnMain' style={{ margin: '0px 0px 0px 10px'}} onClick={() => SaveUpdateClick()}>편집 완료</button>}
                </div>

            </div>
        </div>

    );
}

export default CreatePost;
